import { c as _c } from "react/compiler-runtime";
import React from "react";
import Svg from "../Svg";
const Icon = props => {
  const $ = _c(8);
  const {
    color,
    width,
    height
  } = props;
  const t0 = width || 25;
  const t1 = height || 25;
  const t2 = color || "#1D2939";
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d={"M86 209 c-31 -25 -34 -61 -6 -89 39 -39 110 -11 110 44 0 25 -41 66\n-65 66 -7 0 -24 -9 -39 -21z m79 -23 c28 -43 -18 -91 -63 -67 -26 14 -33 45\n-15 70 19 29 59 27 78 -3z"} />;
    t4 = <path d={"M41 74 c-11 -15 -21 -30 -21 -35 0 -4 -3 -14 -6 -23 -5 -14 8 -16\n110 -16 64 0 116 2 116 5 0 16 -29 72 -43 84 -23 19 -21 5 3 -26 11 -14 20\n-30 20 -34 0 -5 -43 -9 -95 -9 -52 0 -95 4 -95 9 0 4 10 20 21 35 12 15 19 29\n16 32 -2 3 -14 -7 -26 -22z"} />;
    $[0] = t3;
    $[1] = t4;
  } else {
    t3 = $[0];
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t2) {
    t5 = <g transform="translate(0.000000,25.000000) scale(0.100000,-0.100000)" fill={t2} stroke="none">{t3}{t4}</g>;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t5) {
    t6 = <Svg width={t0} height={t1} viewBox="0 0 25 25" stroke="none">{t5}</Svg>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};
export default Icon;